import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
// import "../styling/subscription.css";
import { getActiveSubscriptions } from '../apiCalls/subscription';
import parse from 'html-react-parser';



const Subscription = () => {
    const dispatch = useDispatch();
    const { subscriptions } = useSelector((state) => state.subscription);

    console.log(subscriptions, 'datasele')

    useEffect(() => {
        getActiveSubscriptions(dispatch);
    }, [dispatch]);

    return (
        <section className='subscription'>
            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className='col-12 sub-heading mb-5'>
                        <h3>
                            Choose Plan
                        </h3>
                        <p>
                            Choose the best plan according to your needs hospitals, you just a step far from go into digital world of hospitals.
                        </p>
                    </div>
                    {subscriptions?.data?.map((plan, index) => (
                        <div className="col-md-6 col-lg-3 mb-4" key={index}>
                            <div className={`subs-card h-100 ${plan.isPopular ? "popular-cards" : ""}`}>
                                {plan.isPopular && (
                                    <span className="badge badge-popular">Popular Plan</span>
                                )}
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title">{plan.subsName}

                                        <span>
                                            {plan?.subsDuration} Days
                                        </span>
                                    </h5>
                                    <h6 className="card-price">{plan.subsprice} <span className="text-muted">/{plan?.subsmrp} </span></h6>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        {parse(plan?.description)}
                                    </ul>
                                    <Link to={`/purchase-subscription/${plan?._id}`}>
                                        <button className={`btn btn-outline-primary mt-auto`}>
                                            Choose Plan
                                        </button>
                                    </Link>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    );
}


export default Subscription
